// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Ir-z","badgeLink":"Jr-z","category":"Kr-z"};